// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Txq","tabsBox":"styles_tabsBox__mduwg","createButton":"styles_createButton__1x_8G"};